import BigNumber from "bignumber.js";
import { getBalanceNumber } from "./formatBalance";
import { multicall } from "@wagmi/core";
import { erc20ABI } from "../abis/erc20ABI";
import { config } from "../../services/web3/wagmi";

export const getTokenBalance = async (
  chainId: number,
  account: `0x${string}`,
  tokenAddress: `0x${string}`
) => {
  const erc20Contract = {
    address: tokenAddress,
    abi: erc20ABI,
  } as const;
  const calls = [
    {
      ...erc20Contract,
      functionName: "balanceOf",
      args: [account],
    },
    {
      ...erc20Contract,
      functionName: "decimals",
    },
  ];
  const [balance, decimal] = await multicall(config, {
    contracts: calls,
  });
  return getBalanceNumber(balance.result, decimal.result);
};

export const getETHBalance = async (provider: any, account: string) => {
  const res = await provider.getBalance(account);
  return getBalanceNumber(new BigNumber(res.toString()), 18);
};

export const getAllowance = async (
  chainId: number,
  owner: `0x${string}`,
  spender: `0x${string}`,
  tokenAddress: `0x${string}`
) => {
  const erc20Contract = {
    address: tokenAddress,
    abi: erc20ABI,
  } as const;
  const calls = [
    {
      ...erc20Contract,
      functionName: "allowance",
      args: [owner, spender],
      chainId
    },
    {
      ...erc20Contract,
      functionName: "decimals",
      chainId
    },
  ];
  const [balance, decimal] = await multicall(config, { 
    contracts: calls, 
  })
  return getBalanceNumber(balance.result, decimal.result);
};
